// extracted by mini-css-extract-plugin
export default {"container":"TourDestinationList_container__2ua1m","image":"TourDestinationList_image__lhg+v"};